module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "space"
  }), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_c('a', {
    attrs: {
      "id": "Copyright"
    }
  }, [_vm._v("Copyright © Seaforth Publishing 2007")])]), _c('a', {
    attrs: {
      "id": "Copyright"
    }
  }), _c('p', {
    staticClass: "copyright3"
  }, [_c('a', {
    attrs: {
      "id": "Copyright"
    }
  }, [_vm._v("First published in Great Britain in 2007 by"), _c('br'), _vm._v("\nSeaforth Publishing"), _c('br'), _vm._v("\nAn imprint of Pen & Sword Books Ltd"), _c('br'), _vm._v("\n47 Church Street"), _c('br'), _vm._v("\nBarnsley"), _c('br'), _vm._v("\nS Yorkshire S70 2AS"), _c('br')]), _c('a', {
    attrs: {
      "href": "http://www.pen-and-sword.co.uk",
      "target": "_blank"
    }
  }, [_vm._v("www.pen-and-sword.co.uk")])]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_vm._v("And in the United States of America by"), _c('br'), _vm._v("\nClassic Warships Publishing,"), _c('br'), _vm._v("\nPO Box 57591, Tucson, Arizona 85732"), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.classicwarships.com",
      "target": "_blank"
    }
  }, [_vm._v("www.classicwarships.com")])]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_vm._v("The publishers would like to thank D K"), _c('br'), _vm._v("\nBrown and John Roberts for help with"), _c('br'), _vm._v("\nillustration.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_c('i', [_vm._v("British Library Cataloguing in Publication Data")]), _c('br'), _vm._v("\nBacker, Steve"), _c('br'), _vm._v("\n    British battlecruisers of the Second"), _c('br'), _vm._v("\n    World War. -"), _c('br'), _vm._v("\n  (ShipCraft)"), _c('br'), _vm._v("\n  1. Warships - Models"), _c('br'), _vm._v("\n I. Title II. Richardson, George"), _c('br'), _vm._v("\n 623.8'20153"), _c('br'), _vm._v("\n  ISBN-13: 9781844156986")]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_vm._v("  PAPERBACK ISBN: 978-1-84415-698-6"), _c('br'), _vm._v("\n  PDF ISBN: 978-1-47382-945-9"), _c('br'), _vm._v("\n  EPUB ISBN: 978-1-47382-670-0"), _c('br'), _vm._v("\n  PRC ISBN: 978-1-47382-626-7")]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_vm._v("All rights reserved. No part of this publication"), _c('br'), _vm._v("\nmay be reproduced or transmitted in any form or"), _c('br'), _vm._v("\nby any means, electronic or mechanical,"), _c('br'), _vm._v("\nincluding photocopying, recording, or any"), _c('br'), _vm._v("\ninformation storage and retrieval system, without"), _c('br'), _vm._v("\neither prior permission in writing from the"), _c('br'), _vm._v("\npublisher or a licence permitting restricted"), _c('br'), _vm._v("\ncopying.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_vm._v("Typeset and designed by Sally Geeve"), _c('br'), _vm._v("\nPrinted and bound in China through Printworks"), _c('br'), _vm._v("\nInternational Ltd")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e620bc9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/03_Copyright.vue
// module id = 63
// module chunks = 0